module.exports = __webpack_public_path__ + "img/481dce2.png";